// 国际化英文配置
const en = {
  // 布局大小
  size: {
    default: "Default",
    large: "Large",
    small: "Small",
  },
  // 语言
  language: {
    english: "English",
    chinese: "Chinese",
  },
};
export default en;
